/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import qs from 'qs';
import styled, { css } from 'styled-components';
import { Helmet } from 'react-helmet';
import FitImage from 'components/FitImage';
import ShareWorkOrNote from 'components/WorkPage/ShareWorkOrNote';
import NoteAuthor from 'components/WorkPage/NoteAuthor';
import WorkNoteList from 'components/WorkPage/WorkNoteList';
import NoteMarkdownViewer from 'components/WorkPage/NoteMarkdownViewer';
import Divider from 'components/Divider';
import EditorJsViewer from 'components/EditorJsViewer';
import BasicLoader from 'components/BasicLoader';
import { media } from 'util/Responsive';
import { translate } from 'util/Translator';
import {
  getNote,
  getRelatedNotesList,
} from 'services/api';
import { buildNotePath, findWorkStateBySignedRef } from 'util/workRoute';

const ModdedShareNote = styled(ShareWorkOrNote)`
  margin-top: 25px;
  margin-bottom: 0;
`;

const NoteWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  ${media.tablet`
    padding: 30px;
  `}
`;

const NoteInner = styled.div`
  width: 100%;
  max-width: 435px;
`;

const NoteTitle = styled.div`
  font-family: 'Noto Sans JP';
  font-weight: bold;
  line-height: 1.5em;
  font-size: 20px;
  letter-spacing: 0.03em;
  color: #222222;
`;

const NoteDetails = styled.div`
  margin: 30px 0 0;
`;

const OtherNotesOrRelatedNotesTopDivider = styled(Divider)`
  margin: 60px 0 50px;
`;

const OtherNotesOrRelatedNotesTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0.03em;
  color: #222222;
  margin-bottom: 17px;
`;

const FooterNoteWrap = styled.div`
  background: #4f4f4f;
  border-radius: 5px;
  padding: 20px;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
`;

const RelatedNoteWorkTitleFromWork = styled.div`
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 0.03em;
  color: #bdbdbd;
  margin-right: 7px;
`;

const RelatedNoteWorkTitle = styled.div`
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.03em;
  color: #fbfbfb;
`;

const RelatedNoteWorkTitleWrap = styled.div`
  flex-direction: row;
  margin-bottom: 15px;
  align-items: center;
`;

const FooterNoteInfoWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const FooterNoteThumbnail = styled.div`
  position: relative;
  width: 126px;
  height: 70px;
  margin-right: 10px;
`;

const FooterNoteInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ useLeftPad }) =>
    useLeftPad &&
    css`
      margin-left: 10px;
    `}
`;

const FooterNoteTitle = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-wrap: wrap;
  color: white;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.5em;
`;

class NoteView extends React.Component {
  static async getInitialData(ctx) {
    const { match, dispatch, queryString } = ctx;
    const { owner_screen_name, signed_ref, note_id } = match.params;
    const { secret } = queryString;
    await getNote(
      dispatch,
      owner_screen_name,
      signed_ref,
      undefined,
      note_id,
      secret,
    );
    return { match };
  }

  componentDidMount() {
    const {
      note_id,
      work_id,
      signed_ref,
      ownerScreenName,
      work,
      note,
      dispatch,
      location,
    } = this.props;
    const queryString = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (!note.data.id && ownerScreenName) {
      getNote(
        dispatch,
        ownerScreenName,
        signed_ref,
        work_id,
        note_id,
        queryString.secret,
      );
    }

    if (work.data?.notes_count === 1 && ownerScreenName) {
      getRelatedNotesList(
        dispatch,
        ownerScreenName,
        signed_ref,
        work_id,
        queryString.secret,
      );
    }
  }

  componentDidUpdate(prevProps) {
    const {
      note_id,
      work_id,
      signed_ref,
      ownerScreenName,
      dispatch,
      location,
    } = this.props;
    const { note_id: prevNoteId } = prevProps;
    if (note_id !== prevNoteId && ownerScreenName) {
      const queryString = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });
      getNote(
        dispatch,
        ownerScreenName,
        signed_ref,
        work_id,
        note_id,
        queryString.secret,
      );
    }
  }

  noteDetails = () => {
    const { note } = this.props;
    if (note.data.body_json?.blocks?.length) {
      return <EditorJsViewer data={note.data.body_json} />;
    }
    return <NoteMarkdownViewer data={note.data.body_md} />;
  };

  renderOtherNoteOrRelatedNote = (
    t,
    isShowRelatedNote,
    note,
    work,
    onClickViewNote,
  ) => (
    <Link
      to={buildNotePath(work, note.id)}
      onClick={onClickViewNote}
      key={note.id}
    >
      <FooterNoteWrap>
        {isShowRelatedNote ? (
          <RelatedNoteWorkTitleWrap>
            <RelatedNoteWorkTitleFromWork>
              {t('fromWork')}
            </RelatedNoteWorkTitleFromWork>
            <RelatedNoteWorkTitle>{work.title}</RelatedNoteWorkTitle>
          </RelatedNoteWorkTitleWrap>
        ) : null}
        <FooterNoteInfoWrap>
          {!!note.thumbnail && (
            <FitImage
              src={note.thumbnail}
              customContainer={FooterNoteThumbnail}
              alt={note.title}
            />
          )}
          <FooterNoteInfo useLeftPad={!!note.thumbnail}>
            <FooterNoteTitle>{note.title}</FooterNoteTitle>
            <NoteAuthor note={note} />
          </FooterNoteInfo>
        </FooterNoteInfoWrap>
      </FooterNoteWrap>
    </Link>
  );

  render() {
    const {
      work,
      note: { loading, data },
    } = this.props;
    if (loading) {
      return <BasicLoader />;
    }
    return (
      <NoteWrap>
        {loading && <BasicLoader />}
        {!loading && data && (
          <Fragment>
            <Helmet>
              <title>{`${data.title}`}</title>
              <meta name="description" content={`${data.meta_desc}`} />
              <meta property="og:title" content={`${data.title}`} />
              <meta property="og:description" content={`${data.meta_desc}`} />
              <meta property="og:image" content={`${data.meta_image}`} />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={`${data.title}`} />
              <meta name="twitter:text:title" content={`${data.title}`} />
              <meta name="twitter:description" content={`${data.meta_desc}`} />
              <meta name="twitter:image" content={`${data.meta_image}`} />
            </Helmet>
            <NoteInner>
              <NoteTitle>{data.title}</NoteTitle>
              <NoteAuthor note={data} />
              <NoteDetails>{this.noteDetails()}</NoteDetails>
              <Divider />
              <ModdedShareNote work={work.data} note={data} />
            </NoteInner>
          </Fragment>
        )}
      </NoteWrap>
    );
  }
}

export default translate('notes')(
  connect(({ notes, works }, props) => {
    const { signed_ref, note_id } = props.match.params;
    const work = findWorkStateBySignedRef(works, signed_ref) || {};
    const work_id = work.data?.id;
    const noteWorkKey = work_id || signed_ref;

    const note = {
      data: { details: '', user: { profile: {} } },
      loading: true,
      ...notes[`${noteWorkKey}:${note_id}`],
    };

    const noteList = work.notesList || [];
    const otherNoteList = noteList.filter(
      ({ id }) => id !== parseInt(note_id, 10),
    );
    const relatedNoteList = work.relatedNotesList || [];

    return {
      otherNoteList,
      relatedNoteList,
      work_id,
      signed_ref,
      ownerScreenName:
        work.data?.author?.screen_name || work.data?.screen_name,
      note_id,
      note,
      work,
      ...props.initialData,
    };
  })(NoteView),
);
